import { render, staticRenderFns } from "./SecurityDiagram.vue?vue&type=template&id=8ead4a72&scoped=true"
import script from "./SecurityDiagram.vue?vue&type=script&lang=js"
export * from "./SecurityDiagram.vue?vue&type=script&lang=js"
import style0 from "./SecurityDiagram.vue?vue&type=style&index=0&id=8ead4a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead4a72",
  null
  
)

export default component.exports